import type { FC } from 'react';

import { HelpCaption } from '../captions/help-caption';
import { SupportTitle } from '../captions/support-title';
import { WistiaPlayer } from '../player/wistia-player';

export const AuctionHelpCenterContent: FC = () => {
  const playerHeight = '533px';
  // cspell:ignore wex955xtyx
  const mediaId = 'wex955xtyx';

  return (
    <div className="d-flex flex-direction-column">
      <SupportTitle />
      <HelpCaption>Help with Auction Page</HelpCaption>
      <WistiaPlayer mediaId={mediaId} height={playerHeight} />
    </div>
  );
};
